import React, { useEffect, useState } from 'react';
import {
  Redirect, Route, Switch, useHistory,
} from 'react-router';
import { isEmpty } from 'lodash';
import queryString from 'query-string';
import { useAuth0 } from '@auth0/auth0-react';
import Header from '../Header/Header';
import Hero from '../Hero/Hero';
import Footer from '../Footer/Footer';
import ProductsList from '../Products/ProductsList';
import Sidebar from '../Sidebar/Sidebar';
import Account from '../Account/Account';
import DeleteAccount from '../Account/DeleteAccount';
import ProductSingle from '../ProductSingle/ProductSingle';
import Banner from '../Header/Banner';
import ApiWrapper from '../../helpers/api/api-wrapper';
import Loading from '../Utility/Loading';
import Checkout from '../Checkout/Checkout';
import SuccessfulPayment from '../Checkout/SuccessfulPayment';
import { useShop } from '../../contexts/shop';

const Admin = () => {
  const { push } = useHistory();
  const [isLoadingApiWrapper, setIsLoadingApiWrapper] = useState(true);
  const { getAccessTokenSilently, user: { email, sub: userId } = {}, user } = useAuth0();
  const { sendCartItems, setCartItems } = useShop();
  let parsed = queryString.parse(window.location.search);
  useEffect(() => {
    (async () => {
      try {
        setIsLoadingApiWrapper(true);

        const token = await getAccessTokenSilently();
        //ApiWrapper.setToken(token);
        let mToken = localStorage.getItem('token_shop');
        if (!mToken && userId && email) {
          const { data: token } = await ApiWrapper.getToken(userId, email);
          localStorage.setItem('token_shop', token.token);
          ApiWrapper.setToken(token.token);
        } else {
          ApiWrapper.setToken(mToken);
        }
        // Recuperar cartItems desde localStorage
        const pendingItems = localStorage.getItem('pending_cart_items');
        
        if (pendingItems && parsed.success !== 'true') {
          try {
            const items = JSON.parse(pendingItems);
            setCartItems(items);
            
            localStorage.removeItem('pending_cart_items');
          } catch (error) {
            console.warn(error);
          }
        }
        
        if (parsed.session_id && parsed.success === 'true') {
          console.log('Stripe Checkout return detected:', { session_id: parsed.session_id, success: parsed.success, lineItems: parsed.lineItems });
          try {
            const { data } = await ApiWrapper.verifyPayment({ sessionId: parsed.session_id });
            
            if (data.success && data.paymentStatus === 'paid') {
              const items = parsed.lineItems ? JSON.parse(decodeURIComponent(parsed.lineItems)) : [];
              console.log('Saving payment with items:', items);
              
              await ApiWrapper.sendCartItems(items, userId, email, parsed.session_id);

              delete parsed.session_id;
              delete parsed.lineItems;
              delete parsed.success;
              push('/successfulpayment');
            } else {
              console.log('Payment verification failed:', data);
              push('/?error=true');
            }
          } catch (error) {
            console.error('Error verifying payment:', error);
            push('/?error=true');
          }
        }
        setIsLoadingApiWrapper(false);
      } catch (err) {
        setIsLoadingApiWrapper(false);

        if (err.error === 'login_required') {
          return console.log('login with redirect');
        }
        if (err.error === 'consent_required') {
          return console.log('login with redirect');
        }

        throw err;
      }
    })();
  }, []);

  if (isLoadingApiWrapper) return <Loading />;

  return (
    <>
      <Banner />
      <Header />
      <Switch>
        <Route path="/" exact>
          <Hero />
          <ProductsList />
        </Route>
        <Route path="/cuenta" exact>
          <Hero />
          <Account />
        </Route>
        <Route path="/eliminarcuenta" exact>
          <Hero />
          <DeleteAccount />
        </Route>
        <Route path="/checkout" exact>
          <Checkout />
        </Route>
        <Route path="/successfulpayment" exact>
          <SuccessfulPayment />
        </Route>
        <Route path="/:productId">
          <ProductSingle />
        </Route>
        <Redirect path="/" />
      </Switch>
      <Footer />
      <Sidebar />
    </>
  );
};

export default Admin;
